import React from "react";
import styled from "styled-components";


const Container = styled.div`
  width: 100%;
  height: 10px;
  /* transform: translate(0, 8px); */
  position: absolute;
  display: grid;
  top: 0;
  left: 0;

  ::after {
    content: '';
    position: absolute;
    pointer-events: none;
    top: 0;
    left: 0;
    height: 100%;
    background-color: #7F39FA;
    width: ${({$percent}) => $percent};
  }
`

const Range = styled.input`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  width: 100%;
  height: 10px;
  accent-color: #7F39FA;
  position: relative;
  cursor: pointer;
  background-color: #979797;

  ::-webkit-slider-thumb {
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;

    height: 0px;
    width: 0px;
    border-radius: 50%;
    background: #7F39FA;
  }

  ::-moz-range-thumb {
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;

    height: 0px;
    width: 0px;
    border-radius: 50%;
    background: #7F39FA;
  }

  ::-ms-thumb {
    -ms-progress-appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;

    height: 0px;
    width: 0px;
    border-radius: 50%;
    background: #7F39FA;
  }
`

const Progress = ({ value, onChange, max = '100' }) => {

  const percent = (value * 100) / max

  const handleChange = (e) => onChange(parseInt(e.target.value))

  return (
    <Container $percent={`${percent}%`}>
      <Range
        onChange={handleChange}
        type='range'
        min='0'
        max={(max).toString()}
        value={`${value}`}
      />
    </Container>
  );
};

export default Progress;
